// @flow
import _ from 'lodash';
import url from 'url';

import modals from 'modals';
import Cookies from 'js-cookie';

import { ContextBarContent, DEFAULT_CONTENT_PRIORITY } from './content.js';
import CookieWarningtemplate from '../templates/content-cookie-warning.html';
// eslint-disable-next-line max-len
import ModalTemplate from './components/cookie-warning-modal/templates/cookie-warning-modal-template.html';

export const COOKIE_NAME = 'cookie-notification-disabled';
const COOKIE_EXPIRE_PERIOD = 182;
export class ContentCookieWarning extends ContextBarContent {
	constructor (options) {
		options = _.defaultsDeep(options || {},
			{
				name: 'cookie-warning',
				above: ['default'],
			}
		);
		super(options);

		this.priority = DEFAULT_CONTENT_PRIORITY + 1;

		this.cookiesAgreementLink = url.format(url.parse(
			options.config.cms.pageUrls.s1.cookiesAgreement
		));

		this._modal = this._createModal();

		this.template = {
			html: CookieWarningtemplate(),
			data: this,
		};
	}

	beforeRemove = () => {
		this._setCookie();
	}

	_setCookie = () => {
		Cookies.set(COOKIE_NAME, true, { expires: COOKIE_EXPIRE_PERIOD, path: '/' });
	}

	_createModal = (): Object => {
		const modal = modals.create({
			title: 'Согласие на обработку персональных данных для посетителей сайта',
			template: {
				html: ModalTemplate(),
			},
		});

		return modal;
	}

	openModal = () => {
		modals.show(this._modal);
	}
}